
import { config } from "./config";
export function getVideo(id) {
  for (var i = 0; i < list.length; i++) {
    if (list[i].id == id) return list[i];
  }
  return null;
}
export const list = [
  { id: "school_membership", code: "ldp190a", title: "ویدئوی راهنمای درخواست عضویت مدرسه در کلاسیکو 7", source: "aparat" },
  { id: "announce", code: "eub4m8h", title: "ویدئوی راهنمای ثبت اطلاعیه و آگهی", source: "aparat" },
  { id: "school_send_sms", code: "lftv6r8", title: "ویدئوی راهنمای ارسال پیامک", source: "aparat" },
  { id: "create_print_gradesheet", code: "zsxv804", title: "ویدئوی راهنمای ایجاد و چاپ کارنامه تحصیلی", source: "aparat" },
  { id: "disipline_book", code: "ywg3u9n", title: "ویدئوی راهنمای دفتر انضباط", source: "aparat" },
  { id: "present_absent", code: "epo5zl2", title: "ویدئوی راهنمای حضور و غیاب", source: "aparat" },
  { id: "school_timing", code: "gfud2l4", title: "ویدئوی راهنمای ثبت برنامه هفتگی", source: "aparat" },
  { id: "school_classing_students", code: "yjsyt3c", title: "ویدئوی راهنمای کلایبندی دانش آموزان", source: "aparat" },
  { id: "school_save_students", code: "yasmnz9", title: "ویدئوی راهنمای ثبت لیست دانش آموزان", source: "aparat" },
  { id: "school_teachers", code: "xbpt7a4", title: "ویدئوی راهنمای ثبت لیست همکاران", source: "aparat" },
  { id: "school_create_classes", code: "gpdi5h3", title: "ویدئوی راهنمای ایجاد کلاس ها", source: "aparat" },
  { id: "teacher_notes", code: "dsi3u9s", title: "ویدئوی راهنمای یادداشت های معلم", source: "aparat" },
];